import { Injectable } from '@angular/core';
import { GLOBAL } from '../global';
import { RestApiService } from './helper.httpServices';

@Injectable({
  providedIn: 'root',
})
export class SocialService {
  constructor(private http: RestApiService) {}

  createPost(requestData: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(GLOBAL.socialURL + 'user/feed', requestData)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getTagList(requestData: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(GLOBAL.socialURL + 'user/tag/list', requestData)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getMyPost(requestData) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(GLOBAL.socialURL + 'user/feed/my', requestData)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getPost(requestData) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(GLOBAL.socialURL + 'user/feed/list', requestData)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getCompanyCrauselList(){
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(GLOBAL.socialURL + 'user/company/carousel/list')
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getListSaleTransaction() {
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(GLOBAL.socialURL + 'user/live/carousel/list')
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getLikeCount(postId:any){
    return new Promise((resolve, reject) => {
      this.http.get<any>(GLOBAL.socialURL + 'user/action/count/' + postId).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  like(requestData){
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(GLOBAL.socialURL + 'user/action/like', requestData)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  unlike(requestData){
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(GLOBAL.socialURL + 'user/action/unlike', requestData)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getPostById(postId: any) {
    return new Promise((resolve, reject) => {
      this.http.get<any>(GLOBAL.socialURL + 'user/feed/' + postId).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getProboPostById(postId: any) {
    return new Promise((resolve, reject) => {
      this.http.get<any>(GLOBAL.socialURL + 'user/feed/probo/' + postId).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getAllCommentData(requestData){
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(GLOBAL.socialURL + 'user/comment/list', requestData)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  saveComment(requestData){
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(GLOBAL.socialURL + 'user/comment/create', requestData)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
}
